// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarServiceRequest } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useCancelRegistrarServiceRequest: () => UseMutationResult<
  void,
  string,
  { registrarServiceRequestCid: ContractId<RegistrarServiceRequest> }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['cancelRegistryRegistrarServiceRequest', ledgerApi],
    mutationFn: async ({ registrarServiceRequestCid }) => {
      return ledgerApi.cancelRegistryRegistrarServiceRequest(registrarServiceRequestCid);
    },
    retry: false,
  });
};

export default useCancelRegistrarServiceRequest;
